<template>
  <div id="home" class="home-wrapper">
    <process-status></process-status>
  </div>
</template>

<script>
import ProcessStatus from './ProcessStatus'

export default {
  name: 'home',
  components: {
    ProcessStatus
  },
  methods: {
  },
}
</script>

<style scoped>
.home-wrapper {
  max-width: 1080px;
  margin: 0 auto;
  padding: 24px 16px 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/exhibition/home/Home_ZS.vue